module.exports = __webpack_public_path__ + "static/media/no_contact_tickets.6380c69a.png";